import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-form';
import merge from 'lodash/merge';

import TextInput from 'forms/TextInput';
import SelectInput from 'forms/SelectInput';
import CheckboxInput from 'forms/SelectInput';

import addressesValidator from 'validators/addressesValidator';

class Address extends Component {

  setSameShipping = (e, formApi) => {
    formApi.setValue('billing.sameShipping', !e.target.checked);
    if (!e.target.checked) formApi.setError('shipping', undefined);
  }

  billingCountryChanged = value => {
    if (this.props.values.billing.sameShipping) this.props.changeCountry(value);
  }

  shippingCountryChanged = value => {
    this.props.changeCountry(value);
  }

  render() {
    const formOptions = {
      onSubmit:         values => {
        this.props.setAddresses(values);
        this.props.goNext();
      },
      validate:         addressesValidator,
      defaultValues:    this.props.values,
    };

    return (
      <Form {...formOptions}>
        {formApi => {
          const inputOptions = {
            labelAsPlaceholder: true,
            formApi,
          };

          return (
            <form className="cart-form" onSubmit={formApi.submitForm} noValidate>
              <h1 className="cart-formTitle">{App.t('cart.billing_address')}</h1>

              {this.props.amounts.shipping !== null &&
                <div className="input-block">
                  <label className="input-label">
                    <input type="checkbox" className="input-checkbox" value={!formApi.values.billing.sameShipping} onChange={e => this.setSameShipping(e, formApi)} /> {App.t('cart.different_shipping')}
                  </label>
                </div>
              }

              <div className="cart-form -billing">
                <TextInput name="billing.first_name" label={App.t('order.first_name')} {...inputOptions} />
                <TextInput name="billing.last_name" label={App.t('order.last_name')} {...inputOptions} />
                <TextInput name="billing.company" label={App.t('order.company')} {...inputOptions} />
                <TextInput name="billing.email" label={App.t('order.email')} {...inputOptions} />
                <TextInput name="billing.street" label={App.t('order.street')} {...inputOptions} />
                <TextInput name="billing.post_code" label={App.t('order.postcode')} {...inputOptions} />
                <TextInput name="billing.city" label={App.t('order.city')} {...inputOptions} />
                <SelectInput name="billing.country" label={App.t('order.country')} options={_metadata.countries} {...inputOptions} onChange={this.billingCountryChanged} />
              </div>

              {!formApi.values.billing.sameShipping ?
                <div className="cart-form -shipping">
                  <h2 className="cart-addressTitle">{App.t('cart.shipping_address')}</h2>
                  <TextInput name="shipping.first_name" label={App.t('order.first_name')} {...inputOptions} />
                  <TextInput name="shipping.last_name" label={App.t('order.last_name')} {...inputOptions} />
                  <TextInput name="shipping.company" label={App.t('order.company')} {...inputOptions} />
                  <TextInput name="shipping.street" label={App.t('order.street')} {...inputOptions} />
                  <TextInput name="shipping.post_code" label={App.t('order.postcode')} {...inputOptions} />
                  <TextInput name="shipping.city" label={App.t('order.city')} {...inputOptions} />
                  <SelectInput name="shipping.country" label={App.t('order.country')} options={_metadata.countries} {...inputOptions} onChange={this.shippingCountryChanged} />
                </div>
                : null
              }

              <div className="input-buttons">
                <button type="submit" className={`btn -green ${false ? '-isLoading' : ''}`}>{App.t('cart.go_to_3')}</button>
              </div>
            </form>
          )
        }}
      </Form>
    );
  }

}

Address.propTypes = {
  setAddresses:   PropTypes.func.isRequired,
  goNext:         PropTypes.func.isRequired,
  changeCountry:  PropTypes.func.isRequired,
  values:         PropTypes.object.isRequired,
  amounts:        PropTypes.object.isRequired,
};

export default Address;
